<template>
    <div>
        <el-row class="padded">

          <el-col :span="24">

            <data-table
              v-if="showTable"
              title="Invoices"
              table-ref="invoices"
              url="invoices"
              :fields="fields"
              sort-field="invoiceType">

              <template #odue="props">
                <!-- eslint-disable-next-line vue/no-v-html -- formatter output, numeric → coloured span markup -->
                <span v-html="formatDue(props.rowData.amountPaid, props.rowData.total)"></span>
              </template>

              <template #view="props">
                <el-button
                  size="mini"
                  type="primary"
                  icon="fa fa-chevron-right"
                  round
                  @click="showDetails(props.rowData)">
                  View
                </el-button>

              </template>

            </data-table>

      </el-col>

    </el-row>

    <hr />

    <el-row>
      <el-col :span="24">
       <contractor-invoice-table />
      </el-col>
    </el-row>

    <transition name="fade" :duration="200">

      <div v-if="!showTable">
        <el-button type="text" icon="fa fa-chevron-left"  @click="showTable = true">&nbsp;Back to Invoices</el-button>
        <invoice-details :row-data="invData" />
      </div>

    </transition>
  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

import InvoiceDetails from '@/components/finance/invoice/InvoiceDetails'
import ContractorInvoiceTable from '@/components/finance/invoice/ContractorInvoiceTable'

export default {
  mixins: [SiteMixins],

  components: {
    ContractorInvoiceTable,
    InvoiceDetails
  },

  methods: {

    showDetails (rowData) {
      this.invData = rowData
      this.showTable = !this.showTable
    },

    formatExpiry (value, term = 30) {
      var days = Math.abs(this.fromToday(value))
      var bg = '#DAF7A6'
      var text = 'Current'
      var odue = ''
      var color = '#F9FAFC'

      if (term < 0) {
        term = Math.abs(term)
      }

      if (days >= 0 && days < term) {
        color = '#324057'
      }

      if (days >= term && days < (term * 2)) {
        text = Math.abs(term) + '+ ' + odue
        bg = '#FFC300'
      }

      if (days >= (term * 2) && days < (term * 3)) {
        text = Math.abs(term * 2) + '+ ' + odue
        bg = '#FF5733'
      }

      if (days >= (term * 3) && days < (term * 4)) {
        text = Math.abs(term * 3) + '+ ' + odue
        bg = '#C70039'
      }

      if (days > (term * 4)) {
        text = Math.abs(term * 4) + '+ ' + odue
        bg = '#641E16'
      }

      return '<span style="background: ' + bg +
      '; color:' + color +
       '; border-radius: 11px; padding: 5px;">' +
       text + '</span>'
    },

    formatDue (paid, total) {

      if (!paid || paid <= 0.00) {
        return ''
      }

      var due = total - paid

      var text = ''
      var color = '#878D99'

      if (paid === total) {
        text = '<i class="fa fa-check"></i>'
        color = 'seagreen'
      }

      if (due > total) {
        text = '<i class="fa fa-chevron-up"></i> ' + this.formatInteger(due)
        color = 'indianred'
      }

      if (due < total) {
        text = '<i class="fa fa-chevron-down"></i> ' + this.formatInteger(due)
        color = 'goldenrod'
      }

      return '<strong style="color: ' + color + ';">' + text + '</strong>'
    },

    formatPaid (value) {
      if (value && value > 0) {
        return '<strong style="color: seagreen;">' + this.formatInteger(value) + '</strong>'
      } else {
        return '<span></span>'
      }

    },

    formatTotal (value) {
      return '<strong>' + this.formatInteger(value) + '</strong>'
    }
  },


  data () {
    return {
      showTable: true,
      invData: null,
      hasUtilTransactions: false,
      dueStatus: 'exception',
      gutter: 16,
      textSize: '1.7em',
      utilLabel: this.getUtilLabel(),
      summary: [],
      utilData: [],
      orgData: [],
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'to.name',
          title: 'Company',
          visible: this.isMediumOrMore
        },
        {
          name: 'invoiceNo',
          title: 'Invoice',
          sortField: 'invoiceNo'
        },
        {
          name: 'date',
          title: 'State',
          sortField: 'date',
          callback: this.formatExpiry
        },
        {
          name: 'invoiceType',
          title: 'Type',
          sortField: 'invoiceType',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'total',
          sortField: 'total',
          title: 'TOTAL',
          callback: this.formatTotal
        },
        {
          name: 'amountPaid',
          title: 'Paid',
          callback: this.formatPaid,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: '__slot:odue',
          title: 'O/S',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: '__slot:view'
        }
      ]
    }
  }
}

</script>
